import companydocument from '@/app/clientarea-app/client-document/router'
import chargedocument from '@/app/clientarea-app/charge-document/router'
import atachmentspecificdocument from '@/app/clientarea-app/specific-document/router'
import documentByLink from '@/app/clientarea-app/specific-document/router2'

import vuex from '@/app/state'

export default [{
  path: '/clientarea',
  mode: 'abstract',

  component: () => import('./ClientArea'),
  children: [
    ...companydocument,
    ...chargedocument,
    ...atachmentspecificdocument,
    ...documentByLink
  ],
  async beforeEnter (to, from, next) {
    if (to.path.includes('document-by-link')) {
      await vuex.dispatch('auth/clientAreaAcess', to.query)
      vuex.dispatch('auth/saveClientData', to.query)
      next()
    } else if (to.query && to.query.email) {
      vuex.dispatch('auth/saveClientData', to.query)
      next({ path: to.path, query: {} })
    } else {
      await vuex.dispatch('auth/clientAreaAcess', vuex.getters['auth/clientData'])
      next()
    }
  }
}]
